import { useState } from "react";

/**
 * Forces re-render
 */
export const useRefresh = () => {
  const [state, setState] = useState(false);
  return () => setState(!state);
};
